import { MicroFrontends } from "../../constants/MicroFrontendConfig";
import { MICRO_FRONTENDS_CONFIG } from "../MicroFrontend/MicroFrontendConfig";

export const getMicroFrontendPath = (key: MicroFrontends): string =>
  MICRO_FRONTENDS_CONFIG[key]?.path;

export const getMicroFrontendName = (key: MicroFrontends): string =>
  MICRO_FRONTENDS_CONFIG[key].name;

export const getMicroFrontendSubModuleName = (
  parentKey: MicroFrontends,
  childKey: string
): string => MICRO_FRONTENDS_CONFIG[parentKey]?.subModules?.[childKey]?.name;

export const getMicroFrontendSubmodulePath = (
  parentKey: MicroFrontends,
  childKey: string,
  childPath?: boolean
): string => {
  if (childPath) {
    return `${getMicroFrontendPath(parentKey)}/${
      MICRO_FRONTENDS_CONFIG[parentKey]?.subModules?.[childKey]?.path
    }`;
  } else {
    return MICRO_FRONTENDS_CONFIG[parentKey]?.subModules?.[childKey]?.path;
  }
};

export const getSettingsMicroFrontendPath = (childPath: string): string => {
  return `/${MICRO_FRONTENDS_CONFIG[MicroFrontends.SETTINGS].path}${childPath}`;
};

